<template>
  <div id="app">
      <link rel="stylesheet"
            href="https://use.fontawesome.com/releases/v5.2.0/css/all.css"
            integrity="sha384-hWVjflwFxL6sNzntih27bfxkr27PmbbK/iSvJ+a4+0owXq79v+lsFkW54bOGbiDQ"
            crossorigin="anonymous">
      <link href="https://fonts.googleapis.com/css?family=Didact+Gothic|Roboto" rel="stylesheet">
    <router-view></router-view>
  </div>
</template>
<script>
  import './assets/css/style.css'
  import axios from 'axios'
  import { endPointPrivate } from './services/config'

  export default {
    name: 'App'
  }

  axios.interceptors.request.use(function (config) {
    let restRequest = -1
    let token = ''
    console.log('interceptor')
    restRequest = config.url.indexOf(endPointPrivate)
    if (restRequest !== -1) {
      token = localStorage.token
      config.headers['Authorization'] = 'Token ' + token
      config.headers['Content-Type'] = 'application/json'
      let representanteSelecionado = JSON.parse(localStorage.getItem('representanteSelecionado'))
      if (representanteSelecionado) {
        let codRepresentante = representanteSelecionado.codigo
        if (typeof codRepresentante !== 'undefined' && codRepresentante !== '') {
          config.headers['codRepresentante'] = codRepresentante
        }
      }
    }

    // Do something before request is sent
    return config
  }, function (error) {
    // Do something with request error
    console.log('interceptor')
    return Promise.reject(error)
  })
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  overflow-y: hidden;
  background-color: #f1efef;
  /*margin-top: 90px;*/
}
</style>



// WEBPACK FOOTER //
// src/App.vue